/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Supplier } from '../../models/supplier';

export interface GetSuppliers$Params {

/**
 * Full text search on all the parts of the Supplier entity
 */
  q?: string;
}

export function getSuppliers(http: HttpClient, rootUrl: string, params?: GetSuppliers$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Supplier>>> {
  const rb = new RequestBuilder(rootUrl, getSuppliers.PATH, 'get');
  if (params) {
    rb.query('q', params.q, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Supplier>>;
    })
  );
}

getSuppliers.PATH = '/suppliers';
